import React from 'react';
import Icon from '../components/Icon';
import PageHead from '../components/PageHead';
import { EMERGENCY_NUMBER, SUPPORT_PHONE, SUPPORT_TEL, SUPPORT_WHATSAPP } from '../config/site';
import { usePageMeta } from '../hooks/usePageMeta';

// There is no contact form on purpose. The old one posted to an n8n workflow that no longer exists (checked
// 8 Oct 2026: "webhook not registered"), so messages were lost. Add a form back only after a workflow is rebuilt
// and tested end to end.
const Comments: React.FC = () => {
  usePageMeta(
    'Escríbenos · Violeta',
    '¿Tienes dudas o sugerencias sobre la app Violeta? Escríbenos por WhatsApp. No es para emergencias: si estás en peligro, llama al 911.',
  );

  return (
    <>
      <PageHead
        title="Escríbenos"
        crumb="Contacto"
        lead="¿Tienes una duda sobre la app, encontraste un error o quieres proponer una mejora? Cuéntanos."
      />

      <section className="section contact" aria-labelledby="contact-title">
        <div className="container contact__grid">
          <div className="contact__intro">
            <p className="label">Contacto</p>
            <h2 id="contact-title">Por WhatsApp.</h2>

            <div className="notice" role="note">
              <Icon name="info" />
              <p>
                <strong>Este contacto no es para emergencias.</strong> Los mensajes no se leen al momento. Si estás en
                peligro ahora, llama al{' '}
                <a className="tap" href={`tel:${EMERGENCY_NUMBER}`}>
                  {EMERGENCY_NUMBER}
                </a>
                .
              </p>
            </div>

            <div className="phone-card">
              <small>Teléfono de la app</small>
              <a href={SUPPORT_TEL}>
                <Icon name="phone" />
                {SUPPORT_PHONE}
              </a>
              <small>Para dudas sobre la app. No es una línea de emergencias.</small>
            </div>
          </div>

          <div className="wa-card">
            <h3>Escríbenos por WhatsApp</h3>
            <p>Cuéntanos tu duda o el error que encontraste. Si puedes, di qué versión de la app tienes.</p>
            <a className="btn btn--wa btn--lg" href={SUPPORT_WHATSAPP}>
              <Icon name="chat" />
              Abrir WhatsApp · {SUPPORT_PHONE}
            </a>
            <p className="small-note">No incluyas tu contraseña. No es una línea de emergencias.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Comments;
